var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoVideoBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159 38.1667L125.667 71.5001V42.3334C125.667 37.7501 121.917 34.0001 117.333 34.0001H65.8334L159 127.167V38.1667ZM11.2501 0.666748L0.666748 11.2501L23.4167 34.0001H17.3334C12.7501 34.0001 9.00008 37.7501 9.00008 42.3334V125.667C9.00008 130.25 12.7501 134 17.3334 134H117.333C119.083 134 120.583 133.333 121.833 132.5L148.417 159L159 148.417L11.2501 0.666748Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVideoBig);
export default __webpack_public_path__ + "static/media/noVideoBig.937df128aa15d600010b19f952b185e2.svg";
export { ForwardRef as ReactComponent };